// Unpublished Work © 2021-2023 Deere & Company.

import {KeyNamePair} from '../state/struct/key-name-pair';

export const getSelectedFacetsByName = (facetList, selectedFacets) =>
    facetList.reduce((newList, item) => {
        if (selectedFacets.includes(item.key)) {
            newList.push(item.name);
        }

        return newList;
    }, []);

export const getFacetsKeyByName = (facetList, chipName) => {
    const deleteFacet = facetList.filter((key) => key.name.toUpperCase() === chipName.toUpperCase());

    return deleteFacet[0].key;
};

export const mapKeyValueListToKeyNamePair = (list) =>
    list.map((item) => new KeyNamePair({
        key: item.key,
        name: item.value
    }));

export const mapValuesListToKeyNamePair = (list) =>
    list.map((item, index) => new KeyNamePair({
        key: `${item}_${index}`,
        name: item
    }));

export const isChipNameInFacetList = (facetList, chipName) => {
    const matchedFacetList = facetList.filter((key) => key.name.toUpperCase() === chipName.toUpperCase());

    return matchedFacetList.length > 0;
};

export const focusElementByDataTestId = (dataTestId) => {
    const queryString = `[data-testid=${dataTestId}]`;
    const domElement = globalThis.document.querySelector(queryString);

    if (domElement !== null) {
        domElement.focus();
    }
};

export const focusElementByDataTestIdAndType = (dataTestId, type) => {
    const queryString = `[data-testid=${dataTestId}] ${type}`;
    const domElement = globalThis.document.querySelector(queryString);

    if (domElement !== null) {
        domElement.focus();
    }
};

export const getDomIndexByTextContent = (searchStringInDom, chipName) => {
    const elementList = globalThis.document.querySelectorAll(searchStringInDom);

    let chipIndex = -1;

    elementList.forEach((element, index) => {
        if (chipName === element.textContent) {
            chipIndex = index;
        }
        return chipIndex;
    });
    return chipIndex;
};

export const shouldFocusOnPreviousChip = (chipName, facetList) => { // eslint-disable-line complexity
    const chipIndex = getDomIndexByTextContent('div[data-testid=chip]', chipName);
    const chipsInDocument = globalThis.document.querySelectorAll('div[data-testid=chip]');

    if (chipIndex === 0 || chipsInDocument[chipIndex - 1] === undefined) {
        return false;
    }
    if (isChipNameInFacetList(facetList, chipsInDocument[chipIndex - 1].textContent)) {
        chipsInDocument[chipIndex - 1].children[1].focus();
        return true;
    }
    return false;
};

export const focusOnPreviousChip = (selectedFacets, chipName, facetList, headerDataTestId) => {
    if (selectedFacets.length > 0) {
        if (!shouldFocusOnPreviousChip(chipName, facetList)) {
            focusElementByDataTestId(headerDataTestId);
        }
    } else {
        focusElementByDataTestId(headerDataTestId);
    }
};

const addressElementsIdAndTypeMap = {
    CITY: 3,
    STATES: 4,
    POSTAL_CODE: 5
};

const getAddressElementLabel = (addressElements, id) => {
    const addressElement = addressElements.find((element) => element.id === id);

    return addressElement?.name ?? '';
};

export const adaptFacetLabelsFromAddressElements = (addressElements) => ({
    cityLabel: getAddressElementLabel(addressElements, addressElementsIdAndTypeMap.CITY),
    statesLabel: getAddressElementLabel(addressElements, addressElementsIdAndTypeMap.STATES),
    postalCodeLabel: getAddressElementLabel(addressElements, addressElementsIdAndTypeMap.POSTAL_CODE)
});
